import { useQuery } from "@tanstack/react-query";
import { useDataProvider, type Identifier } from "ra-core";
import type { CrmDataProvider } from "@/components/atomic-crm/providers/types";

/** The client's saved cards / bank accounts and its charge-on-send default. */
export const useClientSavedPaymentMethods = (params: {
  companyId?: Identifier | null;
  contactId?: Identifier | null;
  enabled?: boolean;
  /** A card just saved in the popup: listed even before its customer is linked. */
  includePaymentMethodId?: string | null;
}) => {
  const dataProvider = useDataProvider<CrmDataProvider>();
  return useQuery({
    queryKey: [
      "client-saved-payment-methods",
      params.companyId ?? null,
      params.contactId ?? null,
      params.includePaymentMethodId ?? null,
    ],
    queryFn: () =>
      dataProvider.listClientSavedPaymentMethods({
        companyId: params.companyId ?? null,
        contactId: params.contactId ?? null,
        includePaymentMethodId: params.includePaymentMethodId ?? null,
      }),
    enabled:
      (params.enabled ?? true) && Boolean(params.companyId || params.contactId),
    staleTime: 60_000,
    retry: false,
  });
};
